/**
 * Landbot config
 * 
 * Las propiedades cuyo valor es null por defecto, deben
 * ser definidas en el snippet para funcionar.
 */
const c = UmiCoreConfig;
const emptyObj = (a) => a ? Object.keys(a).length === 0 : true;
c.colors = !emptyObj(c.colors) ? c.colors : {};
c.text = !emptyObj(c.text) ? c.text : {};

const CONFIG = {
  staticUrl: c.staticUrl || null,
  messageLimit: c.messageLimit || 20,
  has_bot: typeof c.has_bot === 'boolean' ? c.has_bot : true,
  // soundUrl: c.soundUrl || null,
  // Colors
  colors: {
    header_text: c.colors.header_text || c.contrast || '#FFFFFF',
    bot_message_background: c.colors.bot_message_background || c.light || '#FFFFFF',
    bot_message_text: c.colors.bot_message_text || c.dark || '#34495E',
    user_message_background: c.colors.user_message_background || c.accent || '#F11952',
    user_message_text: c.colors.user_message_text || c.light || '#FFFFFF',
    button_background: c.colors.button_background || c.accent || '#F11952',
    button_text: c.colors.button_text || c.light || '#FFFFFF',
    textarea_background: c.colors.textarea_background || '#FFFFFF',
    textarea_text: c.colors.textarea_text || '#000000',
    textarea_border: c.colors.textarea_border || c.accent || '#F11952',
    inline_input: c.colors.inline_input || c.contrast || '#FFFFFF',
  },
  text: {
    inline_input_placeholder: c.text.inline_input_placeholder || 'Type your @field here...',
    text_input_placeholder: c.text.text_input_placeholder || 'Type here...',
    fields: c.text.fields || ['name', 'phone', 'email', 'postal code', 'address', 'country', 'birthdate'],
    input_menu_help: c.text.input_menu_help || 'Choose an option',
    input_multi_help: c.text.input_multi_help || 'Choose at least one',
    input_instant_search_help: c.text.input_instant_search_help || 'Filter the options',
    input_text_help: c.text.input_text_help || 'Press enter to send',
    send: c.text.send || 'Send',
    back: c.text.back || 'Back',
    search: c.text.search || 'Search',
    error: c.text.error || '⚠️  It seems there is a technical problem. Please reload this page',
  },
  accent: c.accent || '#F11952',
  dark: c.dark || '#34495E',
  light: c.light || '#FFFFFF',
  contrast: c.contrast || '#FFFFFF',
  header_background: c.header_background || 'transparent',
  // Avatar
  avatar_shape: c.avatar_shape || 'none', // circle, rect, none
  avatar_scale: c.avatar_scale || 1,
  avatar_url: c.avatar_url || (c.logo !== 'none' ? c.logo : false) || 'https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png',
  // Fonts
  font: c.font || 'Montserrat',
  font_size: c.font_size || '15', // XS, S, M, L, LG -> valor numérico?
  // Content variables
  logo: c.logo || 'https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png',
  brand_name: typeof c.brand_name === 'string' ? c.brand_name : 'landbot',
  tagline: typeof c.tagline === 'string' ? c.tagline : 'Get more leads using chatbots 🤖',
  // Background variables
  background_type: c.background_type || 'gradient', // color, gradient, image, video
  background_image_url: c.background_image_url || 'https://storage.googleapis.com/media.yexir.com/channels_back/31.png',
  background_color: c.background_color || '#FFFFFF',
  gradient_from: c.gradient_from || '#FF575B',
  gradient_to: c.gradient_to || '#F11952',
  videoname: c.videoname || 'video_1',
  video_url: c.video_url || null,
  // Filter variables
  filter_type: c.filter_type || 'none', // none, color, gradient, image
  filter_color: c.filter_color || '#000000',
  filter_gradient_from: c.filter_gradient_from || '#FFAD59',
  filter_gradient_to: c.filter_gradient_to || '#FFE199',
  filter_image_url: c.filter_image_url || 'https://storage.googleapis.com/media.yexir.com/channels_back/31.png',
  // External
  stylesheets: !emptyObj(c.stylesheets) ? c.stylesheets : [],
  // Custom
  style: c.style || false,
  // Keywords
  keywords: !emptyObj(c.keywords) ? c.keywords : {},
  persistent_menu: !emptyObj(c.persistent_menu) ? c.persistent_menu : {},
  // Progress
  progress: typeof c.progress === 'number' ? c.progress : false,
  // Test
  test: c.test || false,
  // Branding
  branding: c.branding !== false ? true : false,
  // General settings
  typing: typeof c.typing === 'boolean' ? c.typing : true,
  widget_hide_background: c.widget_hide_background || false,
  widget_hide_header: c.widget_hide_header || false,
};

export default CONFIG;

export const referralHeaderURL = `https://landbot.io/powered-by?utm_source=${CONFIG.brand_name}&utm_medium=landbot&utm_campaign=header`;
export const referralFooterURL = `https://landbot.io/powered-by?utm_source=${CONFIG.brand_name}&utm_medium=landbot&utm_campaign=footer`;


// WEBPACK FOOTER //
// ./app/js/Config.js